import { render } from "./RegistrationCountdown.vue?vue&type=template&id=340aeb15&scoped=true"
import script from "./RegistrationCountdown.vue?vue&type=script&lang=js"
export * from "./RegistrationCountdown.vue?vue&type=script&lang=js"

import "./RegistrationCountdown.vue?vue&type=style&index=0&id=340aeb15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340aeb15"]])

export default __exports__